function variantPicker() {
  const product_infos = document.querySelectorAll('.custom-variants');

  product_infos.forEach((product_info) => {
    // Inputs de quantidade
    const qty_inputs = product_info.querySelectorAll('.qty_input');
    // Inputs de quantidade de cada Variante
    const variant_qty_inputs = product_info.querySelectorAll('.variants__wrapper .quantity__input');
    // Botão de comprar
    const buy_button = product_info.querySelectorAll('.product-form__submit')[0];
    // Botão de aumentar quantidade de cada Variante
    const variant_qty_plus = product_info.querySelectorAll('.quantity__plus');
    // Botão de diminuir quantidade de cada Variante
    const variant_qty_minus = product_info.querySelectorAll('.quantity__minus');
    // Inputs para enviar quantidades de variantes para carrinho
    const variants_quantity = product_info.querySelectorAll('.variant-quantity');
    // Container de cada input de Variante
    const variant_wrapper = product_info.querySelectorAll('.variant-input_wrapper');

    // Preço do produto na Shopify
    const fixed_price = product_info.querySelector('#price-per-item').textContent;
    const fixed_discount_price = product_info.querySelector('#compare-price-per-item').textContent;

    // Preços a serem substituídos
    const old_price = product_info.querySelector('#discount-price');
    const old_regular_price = product_info.querySelector('#regular-price');
    const old_pix_price = product_info.querySelector('#price-pix');
    const pix_discount_html = old_pix_price.getAttribute('data-discount');
    const pix_discount = (100 - pix_discount_html) / 100;

    // Formata número para dinheiro
    function moneyFormat(price) {
      return price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace(/\s/g, '');
    }

    // Função para reverter formatação de dinheiro para número
    function moneyToNumber(price) {
      return Number(price.replace('R$', '').replace('.', '').replace(',', '.'));
    }

    function pricesAndButton(quantity, quantity_max) {
      // Quantidade de sabores escolhidos
      let quantity_put = 0;
      variant_qty_inputs.forEach((item) => {
        quantity_put = quantity_put + parseInt(item.value);
      });

      // Se não tiver o parâmetro de quantidade final na função, pegar a quantidade de sabores já selecionados
      let quantity_selected = quantity_max || quantity_put;
      let qty_discounts = product_info.querySelectorAll('.quantity-input__label');
      let qty_discount = (100 - qty_discounts[quantity - 1].getAttribute('data-discount')) / 100;

      // Substitui preço sem desconto de quantidade
      if (!quantity_max || quantity_max > quantity_put) {
        if (qty_discount < 1 || fixed_discount_price > fixed_price) {
          old_regular_price.classList.remove('visually-hidden');
          old_regular_price.textContent = moneyFormat((fixed_price * quantity) / 100);
        } else {
          old_regular_price.classList.add('visually-hidden');
        }

        // Substitui preço com desconto de quantidade
        old_price.textContent = moneyFormat((fixed_price * qty_discount * quantity) / 100);

        // Substitui preço no pix
        old_pix_price.textContent = moneyFormat((fixed_price * qty_discount * quantity * pix_discount) / 100);
      }

      // Ativar ou desativar botão de acordo com a quantidades
      if (quantity_put > 0 && quantity_put == quantity) {
        buy_button.disabled = false;
      } else {
        buy_button.disabled = true;
      }

      // Bloquear ou desbloquear botões de adicionar de acordo com a quantidades
      variant_qty_plus.forEach((item, idx) => {
        let input = product_info.querySelectorAll(`.input-${idx}`);
        let variant_max = parseInt(input[0].max);
        let value = parseInt(input[0].value);

        if (value >= variant_max || quantity_selected >= quantity) {
          item.disabled = true;
          item.classList.add('disabled');
        } else {
          item.disabled = false;
          item.classList.remove('disabled');
        }
      });
    }

    // Iteração entre todos os inputs de quantidade de produtos
    qty_inputs.forEach((item) => {
      // Evento de clique para cada input de quantidade de produtos
      item.addEventListener('click', function () {
        pricesAndButton(this.value);
      });
    });

    // Função para reforçar mínimo e máximo de quantidade
    function enforceMinMax(el) {
      if (el.value != '') {
        if (parseInt(el.value) < parseInt(el.min)) {
          el.value = el.min;
        }
        if (parseInt(el.value) > parseInt(el.max)) {
          el.value = el.max;
        }
      }
    }
    variant_qty_inputs.forEach((item, i) => {
      item.addEventListener('change', function () {
        enforceMinMax(this);

        if (parseInt(this.value) > 0) {
          variant_wrapper[i].classList.remove('not-chosen');
        } else {
          variant_wrapper[i].classList.add('not-chosen');
        }

        // Mudar valor da quantidade de cada variante de Sabor
        variants_quantity[i].value = this.value;

        // Quantidade de latas escolhida
        const quantity = product_info.querySelector('.qty_input:checked').value;

        pricesAndButton(quantity);
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  variantPicker();

  const modal_openers = document.querySelectorAll('modal-opener button');

  const interval = setInterval(() => {
    let js_modal_openers = document.querySelectorAll('product-recommendations modal-opener button');

    if (js_modal_openers.length > 0) {
      clearInterval(interval);
      js_modal_openers.forEach((modal_opener, index) => {
        modal_opener.addEventListener('click', function () {
          const interval_2 = setInterval(() => {
            const product_info = document.querySelectorAll('.custom-variants')[index];
            if (product_info) {
              clearInterval(interval_2);
              variantPicker();
            }
          }, 1000);
        });
      });
    }
  }, 500);

  modal_openers.forEach((modal_opener, index) => {
    modal_opener.addEventListener('click', function () {
      const interval = setInterval(() => {
        const product_info = document.querySelectorAll('.custom-variants')[index];
        if (product_info) {
          clearInterval(interval);
          variantPicker();
        }
      }, 1000);
    });
  });
});
